export const BASE_URL =
  process.env.REACT_APP_ENV === 'staging' ? 'https://us-central1-meny-stag.cloudfunctions.net/api/' : 'https://us-central1-lynked-demo-tryout.cloudfunctions.net/api/';

export const ELEPAY_URL = 'https://api.elepay.io/';
